export default {"src":"/_next/static/media/mouseflow-small.2fd26a04.svg","height":28,"width":31,"blurWidth":0,"blurHeight":0};